module.exports = __webpack_public_path__ + "img/Doc15b_19830409-005_back.19437dd0.jpg";